import { isFocusable } from './is-focusable.js';

/**
 * @internal
 *
 * Set Attempt to set focus on the current node.
 * @param element - The node to attempt to focus on.
 * @param options - Options to determine if the focus ring should be shown.
 * @returns - true if element is focused.
 */
export const attemptFocus = (
  element: HTMLElement,
  options?: { focusVisible?: boolean },
): boolean => {
  if (!isFocusable(element)) {
    return false;
  }

  try {
    element.focus({ preventScroll: true, ...options });
  } catch {
    // continue regardless of error
  }

  return document.activeElement === element;
};
